module.exports = __webpack_public_path__ + "static/media/visa.d2fb9fc1.svg";